export const SEGMENT_COLOR = {
  START: "#585858",
  DEFAULT: "#D3D3D3",
  SELECTED: "#008000",
  ERROR: "#FF0000"
};

export const SEGMENT_ORIENTATION = {
  EAST: "E",
  WEST: "W",
  NORTH: "N",
  SOUTH: "S",
  EASTNORTH: "EN",
  EASTSOUTH: "ES",
  WESTNORTH: "WN",
  WESTSOUTH: "WS"
};

export const SEGMENT_INF = {
  STRAIGHT: {
    LOGICAL_TYPE: "straight",
    LOGICAL_WIDTH: 10,
    LOGICAL_LENGTH: 30,
    LOGICAL_ROTATION_ANGLE: -45
  },
  ANGLED: {
    LOGICAL_TYPE: "angled",
    LOGICAL_WIDTH: 10,
    LOGICAL_LENGTH: 13,
    LOGICAL_ROTATION_ANGLE: -22.5
  }
};
